export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const REGISTER_SUCCESS= 'REGISTER_SUCCESS';
export const REGISTER_FAIL= 'REGISTER_FAIL';

export const LOGOUT_SUCCESS= 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';